import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Login from './components/Login';
import Layout from './components/Layout';
import WasherList from './components/washers/WasherList';
import UserList from './components/users/UserList';
import UserPage from './components/users/Main';

import SubscriptionList from './components/subscriptions/SubscriptionList';
import ExpirySubscriptionList from './components/subscriptions/ExpirySubscriptionList';
import WashList from './components/washes/WashList';
// import OnDemandWashList from './components/washes/OnDemandWashList';
import RequestList from './components/requests/RequestList';
import WashesTable from './components/washes/WashesTable';
import Discrepancies from './components/washes/Discrepancies';
import ChatList from './components/chats/List';
import ChatBox from './components/chats/ChatBox';
import FeedbackList from './components/feedback/List';
import PendingPaymentsPage from './pages/PendingPaymentsPage';
import NotificationList from './components/notifications/NotificationList';
import BlogsList from './components/blogs/List'
import AddBlog from './components/blogs/AddBlog';
import CarList from './components/cars/CarList';
import FollowUpList from './components/followup/Main';
import CancelledWashes from './components/washes/CancelledWashes';
// import AddNewLamp from './components/lamp/AddNewLamp';

function RequireAuth({ children }) {
  const isLoggedIn = !!JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
  
  if (!isLoggedIn) {
    return <Login />;
  }
  return children;
}

function NotFound() {
  const isLoggedIn = !!JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
  if (!isLoggedIn) {
    return <Login />;
  }
  return <div style={{ textAlign: 'center', marginTop: '20vh', fontSize: 24 }}>Page Not Found</div>;
}

function App() {
  return (
    <GoogleOAuthProvider clientId="836708273130-9tidgrscnjeiluofnljfmfhpajie2257.apps.googleusercontent.com">
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="/requests" />} />
            <Route path="customers" element={<WashesTable />} />
            <Route path="completedwash" element={<WashesTable status='completed'/>} />
            <Route path="cars/list" element={<CarList />} />
            <Route path="requests" element={<RequestList />} />
            <Route path="subscriptions" element={<SubscriptionList />} />
            {/* <Route path="ondemand-washes" element={<OnDemandWashList />} /> */}
            <Route path="washers" element={<WasherList />} />
            <Route path="users" element={<UserList />} />
            <Route path="users/:userId" element={<UserPage />} />
            <Route path="subscription/:subscriptionId" element={<WashList />} />
            <Route path="cancelledsubscriptions" element={<ExpirySubscriptionList />} />
            <Route path="discrepancies" element={<Discrepancies />} />
            <Route path="chat" element={<ChatList />} />
            <Route path="chat/:userId" element={<ChatBox />} />
            <Route path="feedback" element={<FeedbackList />} />
            <Route path="notifications" element={<NotificationList />} />
            <Route path="pending-payments" element={<PendingPaymentsPage />} />
            <Route path="blogs" element={<BlogsList />} />
            <Route path="addBlogs" element={<AddBlog />} />
            <Route path="followups" element={<FollowUpList />} />
            <Route path="cancelled" element={<CancelledWashes />} />
            {/* <Route path="addnewlamp" element={<AddNewLamp />} /> */}
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;